<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :ripple="false" icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item @click="$emit('createUpdate', mission.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-pencil </v-icon>
        <span class="body-2">{{ $t('mission.actions.update') }}</span>
      </v-list-item>

      <v-list-item @click="$emit('duplicateMission', mission.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-content-duplicate </v-icon>
        <span class="body-2">{{ $t('mission.actions.duplicate') }}</span>
      </v-list-item>

      <v-list-item @click="$emit('showMission', mission.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-eye </v-icon>
        <span class="body-2">{{ $t('mission.actions.details') }}</span>
      </v-list-item>

      <v-list-item @click="$emit('getMissionStatus', mission.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-circle-slice-5 </v-icon>
        <span class="body-2">{{ $t('mission.actions.progress') }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'MissionListRowMenu',

  props: {
    mission: {
      type: Object,
      required: true,
    }
  }
}
</script>
